angular
  .module("pe4h")
  .controller("ViewProjects", function (
    $scope,
    $http,
    configuration,
    angularGridInstance
  ) {
    $scope.onScroll = function (scrollTop) {
      angularGridInstance.gallery.handleScroll(scrollTop);
    };

    $scope.generateSEOTitleForProject = function (project) {
      var seoTitle = "contract " + project.LicenseLabel + " job in " + project.City
      return seoTitle.toLowerCase().replace(/ /g, "-");
    }

    // Get public projects
    // load initial public client data
    $scope.loadPublicProjects = function (pageSize, currentPage) {
      $scope.loadingPublicProjects = true;
      $http({
        url: configuration.webApi.projects.publicProjects({
          state: $scope.projectFilters.state && $scope.projectFilters.state.Code ? $scope.projectFilters.state.Code : " ",
          licenseId: $scope.projectFilters.license && $scope.projectFilters.license.Id ? $scope.projectFilters.license.Id : " ",
          pageSize: pageSize,
          currentPage: currentPage
        }),
        method: "GET"
      })
        .success(function (res, status, headers, config) {
          var isStateFilter = $scope.projectFilters.state && $scope.projectFilters.state.Code;
          var isLicenseFilter = $scope.projectFilters.license && $scope.projectFilters.license.Id;

          if (isStateFilter || isLicenseFilter) {
            var newStateFilter = (isStateFilter && $scope.projectFilters.state.Code) != $scope.projectsFiltered.stateCode;
            if (newStateFilter) {
              $scope.projectsFiltered.stateCode = $scope.projectFilters.state.Code;
            }
            var newLicenseFilter = (isLicenseFilter && $scope.projectFilters.license.Id) != $scope.projectsFiltered.licenseId;
            if (newLicenseFilter) {
              $scope.projectsFiltered.licenseId = $scope.projectFilters.license.Id;
            }
            $scope.projectsAll = newStateFilter || newLicenseFilter ? res : $scope.projectsAll.concat(res);
            $scope.projects = newStateFilter || newLicenseFilter ? res : $scope.projects.concat(res);

            $scope.projectsFiltered.status = true;
          } else {
            $scope.projectsAll = !$scope.projectsFiltered.status ? $scope.projectsAll.concat(res) : res;
            $scope.projects = !$scope.projectsFiltered.status ? $scope.projects.concat(res) : res;
            $scope.projectsFiltered.status = false;
            $scope.projectsFiltered.stateCode = null;
            $scope.projectsFiltered.licenseId = null;
          }
          $scope.paging.total = $scope.projects.length;
          $scope.loadingPublicProjects = false;
          $scope.loading = false;

          // Get project locations
          res.forEach(function (item) {
            $http
              .get(
                "https://maps.googleapis.com/maps/api/geocode/json?components=country:US|postal_code:" +
                item.Zip +
                "&sensor=true&key=AIzaSyBhUA7ChLHXS1g5AT1kUbHUoVIQzEvM89w"
              )
              .success(function (resAux) {
                if (resAux.results.length != 0) {
                  $scope.projects.forEach(function (x) {
                    if(x.Id === item.Id){
                      x.latlng = resAux.results[0].geometry.location;;
                    }
                  });
                }
              })
          });
        })
        .error(function (error, status, headers, config) {
          $scope.alertErrorFromServer(error);
          $scope.loadingPublicProjects = false;
        });
    };


    $scope.getMoreProjects = function () {
      if (!$scope.loading && $scope.projectsAll.length % $scope.itemsPerPage === 0) {
        $scope.loading = true;
        $scope.paging.current += 1;

        $scope.loadPublicProjects($scope.itemsPerPage, $scope.paging.current);
      }
    };

    $scope.onLicenseStateChange = function () {
      $scope.paging.current = 1;
      $scope.loadPublicProjects($scope.itemsPerPage, $scope.paging.current);
      $scope.updateProjectsTitle();
    };

    $scope.updateProjectsTitle = function () {
      var currentState = {
        label: $scope.projectFilters.state ? $scope.projectFilters.state.Label : "",
        id: $scope.projectFilters.state ? $scope.projectFilters.state.Code : ""
      }
      var currentLicense = {
        label: $scope.projectFilters.license ? $scope.projectFilters.license.Label : "",
        id: $scope.projectFilters.license ? $scope.projectFilters.license.Id : "",
      }

      if ((!currentState.label || currentState.id === null) && (currentLicense.label && currentLicense.id !== null)) {
        $scope.projectsTitle = "Projects for " + currentLicense.label + "s";
      }
      if ((!currentState.label || currentState.id === null) && (!currentLicense.label || currentLicense.id === null)) {
        $scope.projectsTitle = "Projects";
      }
      if (currentState.label && currentState.id !== null && (!currentLicense.label || currentLicense.id === null)) {
        $scope.projectsTitle = "Projects in " + currentState.label;
      }
      if (currentState.label && currentState.id !== null && currentLicense.label && currentLicense.id !== null) {
        $scope.projectsTitle = "Projects for " + currentLicense.label + "s in " + currentState.label;
      }
    };

    function init() {
      $scope.assetsUrl = configuration.assetsUrl;
      $scope.distance = 3000;
      $scope.loading = true;
      $scope.projects = [];
      $scope.projectsTitle = "Projects";
      $scope.projectsAll = [];
      $scope.projectsFiltered = {
        status: false,
        stateCode: null,
        licenseId: null
      };

      var allLicenses = {
        Id: null,
        Label: "Licenses (All)",
        Available: true
      };

      var allStates = {
        Code: null,
        Label: "States (All)",
        Available: true
      };

      $scope.projectLicenses = angular.copy($scope.licenses);
      $scope.projectLicenses.unshift(allLicenses);

      $scope.projectStates = angular.copy($scope.states);
      $scope.projectStates.unshift(allStates);


      $scope.projectFilters = {
        state: null,
        license: null
      };

      // Paging
      $scope.itemsPerPage = 9;
      $scope.loadingPublicProjects = false;
      $scope.paging = {
        current: 1
      };
      $scope.loadPublicProjects($scope.itemsPerPage, $scope.paging.current);
    }

    init();
  });
